import React from "react";
import "../Footer.css";
import logo from "../../assets/logo-4.png";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiMapPin,
  FiMail,
  FiPhone,
  FiClock,
} from "react-icons/fi";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      {/* ================= CTA ================= */}

      <section className="footer-cta">
        <div className="container">

          <div className="cta-box">

            <div className="cta-content">
              <span className="cta-tag">
                Build Your Digital Business
              </span>

              <h2>
                Ready to Launch Your Next
                <span> E-Commerce Platform?</span>
              </h2>

              <p>
                Kishancart Digital helps startups, retailers and enterprises
                build secure, scalable and modern e-commerce solutions that
                accelerate business growth.
              </p>
            </div>

            <div className="cta-buttons">

              <a
                href="/get-quote"
                className="primary-btn"
              >
                Get a Quote
                <FiArrowRight />
              </a>

              <a
                href="/contact"
                className="secondary-btn"
              >
                Get free Consultation
                <FiArrowRight />
              </a>

            </div>

          </div>

        </div>
      </section>

      {/* ================= Main Footer ================= */}


      <section className="footer-main">

        <div className="container footer-grid">

          {/* Company Info */}

          <div className="footer-column company-column">

            <img
              src={logo}
              alt="Kishancart Digital"
              className="footer-logo"
            />

            <p>
              Kishancart Digital (OPC) Private Limited is a technology-driven
              company specializing in e-commerce development, mobile
              applications, digital transformation and business solutions for
              startups, retailers and enterprises.
            </p>

          </div>

          {/* Company */}

          <div className="footer-column">

            <h3>Company</h3>

            <a href="/about">About Us</a>

            <a href="/our-story">Our Story</a>

            <a href="/mission-vision">
              Mission & Vision
            </a>

            <a href="/contact">
              Contact
            </a>

          </div>

          {/* Industries */}

          <div className="footer-column">

            <h3>Solutions</h3>

            <a href="/retail">
              Retail
            </a>

            <a href="/healthcare">
              HealthCare
            </a>

            <a href="/agriculture">
              Agriculture
            </a>

            <a href="/education">
              Education
            </a>

            <a href="/logistics">
              Logistics
            </a>

            <a href="/manufacturing">
              Manufacturing
            </a>

            <a href="/grocery">
              Grocery
            </a>

            <a href="/fashion">
              Fashion
            </a>



          </div>

          {/* Solutions */}

          <div className="footer-column">

            <h3>Industries</h3>

            <a href="/healthcare">
              HealthCare
            </a>

            <a href="/manufacturing">
              Manufacturing
            </a>

            <a href="/agriculture">
              Agriculture
            </a>

            <a href="/education">
              Education
            </a>



          </div>

          {/* Contact */}

          <div className="footer-column">

            <h3>Contact</h3>

            {/* Address */}

            <a
              href="https://www.google.com/maps/search/?api=1&query=603+A6,+MD+Complex,+Lalganesh+Lokhra+Road,+Odalbakra,+Kamrup,+GMC,+Assam+781034"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item"
            >
              <FiMapPin className="contact-icon" />
              <span>
                603 A6, MD Complex, Lalganesh Lokhra Road,
                Odalbakra, Kamrup, GMC, Assam, India - 781034
              </span>
            </a>

            <a
              href="tel:+913617701489"
              className="contact-item"
            >
              <FiPhone className="contact-icon" />
              <span>+91 361 770 1489</span>
            </a>

            <a
              href="mailto:contact@opckishancart-digital.in"
              className="contact-item"
            >
              <FiMail className="contact-icon" />
              <span>contact@opckishancart-digital.in</span>
            </a>

            <div className="contact-item">
              <FiClock className="contact-icon" />
              <span>
                Mon - Sat
                <br />
                9:00 AM - 6:30 PM
              </span>
            </div>

          </div>

        </div>

      </section>

      {/* ================= Bottom ================= */}

      <section className="footer-bottom">

        <div className="container footer-bottom-content">

          <p>
            © {year} Kishancart Digital (OPC) Private Limited.
            All Rights Reserved.
          </p>

          {/* <div className="footer-bottom-links">

            <NavLink to="/privacy-policy">
              Privacy Policy
            </NavLink>

            <NavLink to="/terms-and-conditions">
              Terms & Conditions
            </NavLink>

            <NavLink to="/disclaimer">
              Disclaimer
            </NavLink>

            <NavLink to="/sitemap">
              Sitemap
            </NavLink>

          </div> */}

        </div>

      </section>

    </footer>
  );
};

export default Footer;